import apiClient from "../../utils/apiclient";
 export const teamform=async(reqBody:{
   
   first_name:string,
   last_name:string,
   mobile_num:string,
   company_email_id:string,
  
   team_id: string;         
   module_id: string[]; 
   mainmodule_id:number[]
    module_owner:string;
   login_password:string
 
  
},token:string)=>{
  return await apiClient.post('/admin/team-member/add',reqBody,{
     headers:{
          Authorization: `Bearer ${token}`
     }
  })

}
  


export const moduleowner=async(reqBody:{
   
   first_name:string,
   last_name:string,
   mobile_num:string,
   company_email_id:string,
   
   module_owner_email: string;         
   module_id: string[];   
   login_password:string
   
  
},token:string)=>{
  return await apiClient.post('/admin/team-member/add_moduleowner',reqBody,{
     headers:{
          Authorization: `Bearer ${token}`
     }
  })

}



export const getTeamById = async (id: string, token?: string) => {
    // Directly insert teamid into the URL path
    const url = `/admin/team-member/getbyteambyid/${id}`;
    
    return await apiClient.get(url, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};
// export const approverequest = async (reqBody:is_approved)(id: string, token?: string) => {
//     // Directly insert teamid into the URL path
//     const url = `/admin/team-member/approve-request/${id}`;
    
//     return await apiClient.post(url, {
//         headers: {
//             Authorization: `Bearer ${token}`,
//         },
//     });
// };





export const approverequest = async (
  id: number,
  is_approved: string,
  token: string
) => {
  const reqBody = { is_approved, id };

  return await apiClient.post(
    `/admin/team-member/approve-request`,
    reqBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};



export const getmodulename = async (
  id: number[],
  
  token: string
) => {
  const reqBody = { id };

  return await apiClient.post(
    `/admin/team-member/get-module-data`,
    reqBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getteammaneid = async (
  id: number,
  
  token: string
) => {
  const reqBody = { id };

  return await apiClient.post(
    `/admin/team-member/renew-role`,
    reqBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};



export const approverejectediteamform = async (
  id: number,
  status:string,
  
  token: string
) => {
  const reqBody = { id,status };

  return await apiClient.post(
    `/admin/team-member/approve-edit-req`,
    reqBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};


  export const pauseaccount = async (
    id: string,
    reqBody: { status: string },
    token: string
  ) => {
    return await apiClient.post(
      `/admin/team-member/update-status/${id}`,
      reqBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  };
  
export const getmodules = async (id:string,email: string, role:string, token?: string) => {
  return await apiClient.post(
    '/admin/team-member/get-modules-list',
    { id,email,role }, // request body
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

  

  export const getmodulesowner = async (token?: string) => {
    return await apiClient.get('/admin/team-member/get-module-list-formodules', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };
  


  export const getteamlist = async (token?: string) => {
    return await apiClient.get('/admin/team-member/get-teams-list', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };


  export const filterdata = async (token?: string) => {
    return await apiClient.get('/admin/team-member/team-FilterData', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  export const editteamform = async (
    id: string, // this is the actual member's ID
    reqBody: {
      first_name: string,
      last_name: string,
      mobile_num: string,
      company_email_id: string,
      team_id: string,
      module_id: string,
      login_password: string
      mainmodule_id:number[]
    },
    token: string
  ) => {
    const url = `/admin/team-member/edit/${id}`;
    return await apiClient.post(url, reqBody, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };
  



  
export const updatemember = async (
  id: string,
  token: string,
  body: {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    company_email_id: string;
    team_name: string;
    module_name: string;
    module_owner: string | null;
    // module_owner_email: string | null;
  }
) => {
  const url = `/admin/team-member/update-member/${id}`;
  return await apiClient.post(url, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


 
export const profiledata = async (
   body:{id:string},
  token?: string, 
) => {
  const url = `/admin/team-member/get-profile-data`;

  return await apiClient.post(url, body,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};




